import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";
import { appointmentFromApiData } from "contexts/appointments/utils";

/**
 * Query appointment
 */
export default async function queryAppointment(
  appointmentId: number,
  onBehalfOf?: string,
): Promise<AppointmentMetaData> {
  const res = await fetchOrchidAPI(
    `/api/scheduler/v1/snapshot/appointment${
      onBehalfOf ? `?on_behalf_of=${onBehalfOf}` : ""
    }`,
    {
      method: "POST",
      body: JSON.stringify({
        appointment_ids: [appointmentId],
      }),
    },
  );
  if (!res.ok) {
    throw new Error(getErrorDetail(await res.text()));
  }

  const data = await res.json();
  return appointmentFromApiData(data.appointments[0]);
}
